import { REVENUE_ACTION_TYPE } from './Type';

const INITIAL_STATE = {
	period: { data: [], totalAmount: 0, count: 0 },
	allTime: { totalAmount: 0 , completedJobsCount: 0 , data:null },
	previousPeriod: { totalAmount: 0 },
	extendGraceMessage: null,
	jobs : null,
	allTaxPros : null,
	allUsers : null,
	loading: false,
	exportData: null,
	syncAllFromStripe: { loading: false, data: null, error: null },
};

const revenueReducer = (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case REVENUE_ACTION_TYPE.setPeriodData:
			return { ...state, period: action.payload };
		case REVENUE_ACTION_TYPE.setAllTimeData:
			return { ...state, allTime: action.payload };
		case REVENUE_ACTION_TYPE.setPreviousPeriodData:
			return { ...state, previousPeriod: action.payload };
		case REVENUE_ACTION_TYPE.setAllTaxPros:
			return { ...state, allTaxPros: action.payload };
		case REVENUE_ACTION_TYPE.setLoading:
			return { ...state, loading: action.payload };
		case REVENUE_ACTION_TYPE.setExportData:
			return { ...state, exportData: action.payload };
		case REVENUE_ACTION_TYPE.clearExportData:
			return { ...state, exportData: null };
		case REVENUE_ACTION_TYPE.setAllUsers:
			return { ...state, allUsers: action.payload };
		case REVENUE_ACTION_TYPE.setAllJobs:
			return { ...state, jobs: action.payload };
		case REVENUE_ACTION_TYPE.extendGracePeriodByAdmin:
			return { ...state, extendGraceMessage: action.payload };
		case REVENUE_ACTION_TYPE.syncAllFromStripe:
			return { ...state, syncAllFromStripe: action.payload };
		default:
			return state;
	}
};

export default revenueReducer;
